import React, { useState, useRef } from 'react'
import coverPhotoContImage from '../Images/default-cover.gif'
import profilePictureContImage from '../Images/defprofile.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft} from '@fortawesome/free-solid-svg-icons'
import swal from 'sweetalert';
import Alert from 'react-bootstrap/Alert';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';


// firebase
import {db} from '../firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, query, getDocs, where } from "firebase/firestore";
import { doc, updateDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

//routers
import {useNavigate } from "react-router-dom";

function UpdateaccountComp() {
    //states
  const [loggedInUser, setLoggedInUser] = useState("");
  const [userNationality, setNationality] = useState("");

    //states
    const [userEmail, setUserEmail] = useState("");
    const [userPhone, setUserPhone] = useState("");
    const [userWebsite, setUserWebsite] = useState("");
    const [userAbout, setUserAbout] = useState("");
    const [userExpectation, setUserExpectation] = useState("");
    const [userCourse, setUserCourse] = useState("");
    const [userSessionTime, setUserSessionTime] = useState("");
    const [userClassType, setUserClassType] = useState("");
  
  
    //update user state
    const [updateUserWebsite, setUpdateUserWebsite] = useState("");
    const [updateUserGithub, setUserGithub] = useState("");


  //get data from input
  const phoneRef = useRef();
  const githubRef = useRef();
  const websiteRef = useRef();
  const aboutMeRef = useRef();
  const expectationsRef = useRef();



  const [userProfilePicture, setProfilePicture] = useState("");
  const [userCoverPicture, setCoverPicture] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertTwo, setShowAlertTwo] = useState(false);
  const [UploadBtn, setUploadBtn] = useState("Upload");
  const [uploadProfileStatus, setuploadProfileStatus] = useState("1");
  const [uploadStatStatus, setuploadStatStatus] = useState("Uploading...0%");



  //use ref
  const fileInput = useRef();
  const coverInput = useRef();

  //instantiate storage
  const storage = getStorage();

  //instantiate aut
  const auth = getAuth();

  onAuthStateChanged(auth, (user) => {
    if (user) {
    //if user is logged in 
    const uid = user.uid;

    const q = query(collection(db, "Employees"), where("docId", "==", uid));
    getDocs(q).then((QuerySnapshot)=>{
        QuerySnapshot.forEach((doc)=>{

        const username = doc.data().employeeName;
        const nationality = doc.data().country;
        const profilePic = doc.data().profilePic;
        const coverPhoto = doc.data().coverPhoto;

        const whyInterested = doc.data().whyInterested;
        const aboutMe = doc.data().aboutMe;
        const phoneNumber = doc.data().employeePhone;
        const userEmail = doc.data().userEmail;
        const userWebsite = doc.data().userWebsite;
        const userGithub = doc.data().userGithub;
        const highSchoolMath =  doc.data().highSchoolMath;
        const educationLevel = doc.data().educationLevel;

        const course = doc.data().course;
        const sessionTime = doc.data().sessionTime;
        const classType = doc.data().classType;


        setUserEmail(userEmail);
        setUserPhone(phoneNumber);
        setUserWebsite(userWebsite);
        setUserAbout(aboutMe);
        setUserExpectation(whyInterested);

        setUserCourse(course);
        setUserSessionTime(sessionTime);
        setUserClassType(classType);

        //update
        setUpdateUserWebsite(userWebsite);
        setUserGithub(userGithub);


        setLoggedInUser(username);
        setNationality(nationality);
        //setProfilePicture(profilePic);
        //setCoverPicture(coverPhoto);


        

        let myxx = profilePic + "1";
        let myYY = coverPhoto + "1";


        if(myxx === "undefined1"){
          setProfilePicture("");         
        }else{
          setProfilePicture(profilePic);
        }

        //
        if(myYY === "undefined1"){
          setCoverPicture(coverPhotoContImage);
        }else{
          setCoverPicture(coverPhoto);
        }

        })
    })

    //update user profile
    window.updateProfile = function(){

    //getting value from ref
    const phoneValue = phoneRef.current.value;
    const githubValue = githubRef.current.value;
    const websiteValue = websiteRef.current.value;
    const aboutMeValue = aboutMeRef.current.value;
    const expectationValue = expectationsRef.current.value;


    updateDoc(doc(db, "Employees", user.uid), {
        employeePhone: phoneValue,
        userGithub:githubValue,
        userWebsite: websiteValue,
        aboutMe:aboutMeValue,
        whyInterested: expectationValue

    }).then(()=>{
        window.location.reload(false);
    })     
    
    }
    //end

    //update profile picture 
    window.saveProfilePhoto = function(){
        const profilePhoto = fileInput.current.files[0];   

        const storageRef = ref(storage, 'images/' + Math.random() + profilePhoto.name);
        const uploadTask = uploadBytesResumable(storageRef, profilePhoto);

        uploadTask.on('state_changed', 
            (snapshot) => {
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                setShowAlert(true);              
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                const roundedOffProgress = Math.round(progress);

                setuploadProfileStatus(roundedOffProgress);
                setuploadStatStatus('Upload is ' + roundedOffProgress + '% done');
                setUploadBtn("Uploading.."+roundedOffProgress +'%')
                
            }, 
        (error) => {
            // Handle unsuccessful uploads
        }, 
        () => {
            // Handle successful uploads on complete
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                updateDoc(doc(db, "Employees", user.uid), {
                    profilePic: downloadURL

                }).then(()=>{
                    swal("Success", "Profile picture updated successfully!", "success").then((value) => {
                        window.location.reload(false);
                      });
                    //
                })  
            });
        }
        );
    }
    //end profile picture


    //update Cover photo
    window.saveCoverPhoto = function(){

        const coverPhoto = coverInput.current.files[0];   

        const storageRef = ref(storage, 'images/' + Math.random() + coverPhoto.name);
        const uploadTask = uploadBytesResumable(storageRef, coverPhoto);

        uploadTask.on('state_changed', 
            (snapshot) => {
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                setShowAlertTwo(true);              
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                const roundedOffProgress = Math.round(progress);

                setuploadProfileStatus(roundedOffProgress);
                setuploadStatStatus('Upload is ' + roundedOffProgress + '% done');
                setUploadBtn("Uploading.."+roundedOffProgress +'%')
                
            }, 
        (error) => {
            // Handle unsuccessful uploads
        }, 
        () => {
            // Handle successful uploads on complete
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                updateDoc(doc(db, "Employees", user.uid), {
                    coverPhoto: downloadURL

                }).then(()=>{
                    swal("Success", "Cover photo updated successfully!", "success").then((value) => {
                        window.location.reload(false);
                      });
                    //
                })  
            });
        }
        );

    }
        } else {
        // User is signed out
        }
    });

    //update profile picture on select
    function updateProfilePhoto(){
        const profilePhoto = fileInput.current.files[0];
        const url = URL.createObjectURL(profilePhoto);
        setProfilePicture(url)
    }

    //update profile picture on select
    function updateCoverPhoto(){
        const profilePhoto = coverInput.current.files[0];
        const url = URL.createObjectURL(profilePhoto);
        setCoverPicture(url)
    }

    //go to profile
    let navigate = useNavigate();
    function goToProfilePage(){
        navigate("/profile")
    }



  return (
    <div className='editProfilePage'>
        <div className='editHero'>
            <div className='editHeroCover'>
                <img src={userCoverPicture} alt="" />
            </div>
            <div className='editHeroOverlay'></div>
            <div className='editHeroContent'>
                <div className='editHeroAvatar'>
                    <img src={userProfilePicture || profilePictureContImage} alt="" />
                </div>
                <div className='editHeroText'>
                    <h3>{loggedInUser || "Instructor Profile"}</h3>
                    <p><FontAwesomeIcon icon={faMapMarkerAlt} className="profileLocationIcon"/> {userNationality || "Update your location"}</p>
                    <div className='editHeroChips'>
                        <span>{userCourse || "Course not set"}</span>
                        <span>{userClassType || "Class type"}</span>
                        <span>{userSessionTime || "Session time"}</span>
                    </div>
                </div>
                <button className='editHeroBack' onClick={goToProfilePage}>
                    <FontAwesomeIcon icon={faArrowLeft} className="profileLocationIcon"/> Back to profile
                </button>
            </div>
        </div>

        <div className='editGrid'>
            <div className='editCard editCardWide'>
                <div className='editCardHeader'>
                    <h6>Profile Photos</h6>
                    <p>Update your instructor profile picture and cover image.</p>
                </div>

                <div className='editUploadGrid'>
                    <div className='editUploadCard'>
                        <div className='editUploadPreview editUploadPreviewAvatar'>
                            <img src={userProfilePicture || profilePictureContImage} alt="" />
                        </div>
                        <div>
                            <p>Profile Picture</p>
                            <div className='editUploadRow'>         
                                <input type="file" ref={fileInput} className="form-control editInput" onChange={updateProfilePhoto}/>             
                                <button className='editUploadButton' onClick={window.saveProfilePhoto}>{UploadBtn}</button>
                            </div>
                            {showAlert && 
                                <Alert className='mt-3'>
                                    {uploadStatStatus}
                                    <ProgressBar striped variant="info" now={uploadProfileStatus} />
                                </Alert>
                            }
                        </div>
                    </div>

                    <div className='editUploadCard'>
                        <div className='editUploadPreview'>
                            <img src={userCoverPicture} alt="" />
                        </div>
                        <div>
                            <p>Cover Photo</p>
                            <div className='editUploadRow'>         
                                <input type="file" ref={coverInput} className="form-control editInput" onChange={updateCoverPhoto}/>             
                                <button className='editUploadButton' onClick={window.saveCoverPhoto}>{UploadBtn}</button>
                            </div>
                            {showAlertTwo && 
                                <Alert className='mt-3'>
                                    {uploadStatStatus}
                                    <ProgressBar striped variant="info" now={uploadProfileStatus} />
                                </Alert>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className='editCard'>
                <div className='editCardHeader'>
                    <h6>Contact & Links</h6>
                    <p>Keep your instructor contact details current.</p>
                </div>

                <div className='editFormGrid'>
                    <div className='editField'>
                        <label htmlFor="">Phone number</label>
                        <input type="text" className='form-control editInput' ref={phoneRef} defaultValue={userPhone} placeholder='eg +254'/>
                    </div>

                    <div className='editField'>
                        <label htmlFor="">Github Account Link</label>
                        <input type="text" className='form-control editInput' ref={githubRef} defaultValue={updateUserGithub} placeholder='https://github.com/user-name'/>
                    </div>

                    <div className='editField'>
                        <label htmlFor="">Portfolio website</label>
                        <input type="text" className='form-control editInput' ref={websiteRef} defaultValue={updateUserWebsite}  placeholder='www.example.me'/>
                    </div>
                </div>
            </div>

            <div className='editCard'>
                <div className='editCardHeader'>
                    <h6>Teaching Profile</h6>
                    <p>This is what students see when they open your profile.</p>
                </div>

                <div className='editFormGrid'>
                    <div className='editField'>
                        <label htmlFor="">About Me</label>
                        <textarea className='form-control editInput editTextarea' rows="4" ref={aboutMeRef} defaultValue={userAbout}></textarea>
                    </div>
                    <div className='editField'>
                        <label htmlFor="">Teaching focus</label>
                        <textarea className='form-control editInput editTextarea' rows="4" ref={expectationsRef} defaultValue={userExpectation}></textarea>
                    </div>
                </div>

                <div className='editActions'>
                    <Button className='editPrimaryButton' onClick={window.updateProfile}>Update Info</Button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default UpdateaccountComp
